import { Routes, UrlMatcher, UrlSegment } from '@angular/router';

export const productMatcher: UrlMatcher = (segments: UrlSegment[]) => {
    if (segments.length > 0 && segments[0].path === 'product') {
        const posParams: { [key: string]: UrlSegment } = {};
        if (segments.length >= 3) {
            posParams['uuid'] = segments[2];
        }
        return { consumed: segments, posParams };
    }
    return null;
};
import { authGuard, publicGuard, profileSetupGuard, setupBlockGuard } from './core/providers/guards/auth-guard';
import { LayoutComponent } from './shared/layout/layout/layout.component';

export const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule),
        title: 'Auth - FoodTraze',
        canActivate: [publicGuard]
    },
    {
        path: 'profile-setup/:uuid',
        loadComponent: () => import('./features/profile-setup/profile-setup.component').then(c => c.ProfileSetupComponent),
        title: 'Profile Setup - FoodTraze',
        canActivate: [profileSetupGuard]
    },

    {
        path: '',
        component: LayoutComponent,
        title: 'Home',
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('./features/dashboard/dashboard.module')
                        .then((m) => m.DashboardModule),
                title: 'Dashboard - FoodTraze'
            },
            {
                path: 'ledger',
                loadChildren: () =>
                    import('./features/ledger/ledger.module')
                        .then((m) => m.LedgerModule),
                title: 'Asset Ledger - FoodTraze'
            },
            {
                path: 'users',
                loadChildren: () =>
                    import('./features/user-management/user-management.routes')
                        .then((m) => m.routes),
                title: 'User Management - FoodTraze'
            },
            {
                path: 'asset-progress',
                loadChildren: () =>
                    import('./features/asset-progress/asset-progress.module')
                        .then((m) => m.AssetProgressModule),
                title: 'Asset Progress - FoodTraze'
            },
            {
                path: 'my-profile',
                loadComponent: () => import('./features/my-profile/my-profile').then(c => c.MyProfile),
                title: 'My Profile FoodTraze',
            },
            {
                path: 'qr-traceability',
                loadChildren: () =>
                    import('./features/qr-traceability/qr-traceability.module')
                        .then(m => m.QrTraceabilityModule),
                title: 'QR Traceability - FoodTraze'
            },
            {
                path: 'roles-permissions',
                loadChildren: () =>
                    import('./features/roles-permissions/roles-permissions.module')
                        .then(m => m.RolesPermissionsModule),
                title: 'Roles & Permissions - FoodTraze'
            },
            {
                path: 'branch-master',
                loadChildren: () =>
                    import('./features/branch-master/branch-master.module')
                        .then(m => m.BranchMasterModule),
                title: 'Branch Master - FoodTraze'
            },
            {
                path: 'asset-transfer',
                loadChildren: () =>
                    import('./features/asset-transfer/asset-transfer-module')
                        .then(m => m.AssetTransferModule),
                title: 'Asset Transfer - FoodTraze'
            },
            {
                path: 'compliance',
                loadComponent: () =>
                    import('./features/compliance/compliance')
                        .then(c => c.Compliance),
                title: 'Compliance - FoodTraze',
                canActivate: [authGuard]
            },
            {
                path: 'compliance/reports',
                loadComponent: () =>
                    import('./features/compliance/compliance-reports/compliance-reports.component')
                        .then(c => c.ComplianceReportsComponent),
                title: 'Compliance Reports - FoodTraze',
                canActivate: [authGuard]
            },
            {
                path: 'compliance/preview',
                loadComponent: () =>
                    import('./features/compliance/compliance-preview/compliance-preview.component')
                        .then(c => c.CompliancePreviewComponent),
                title: 'Compliance Report Preview - FoodTraze',
                canActivate: [authGuard]
            },
            {
                path: 'compliance/config/:id',
                loadComponent: () =>
                    import('./features/compliance/regime-master-config/regime-master-config.component')
                        .then(c => c.RegimeMasterConfigComponent),
                title: 'Compliance Configuration - FoodTraze',
                canActivate: [authGuard]
            },
            {
                path: 'compliance/config',
                loadComponent: () =>
                    import('./features/compliance/regime-master-config/regime-master-config.component')
                        .then(c => c.RegimeMasterConfigComponent),
                title: 'Compliance Configuration - FoodTraze',
                canActivate: [authGuard]
            },
            {
                path: 'report-center',
                loadChildren: () =>
                    import('./features/report-center/report-center.routes')
                        .then(m => m.routes),
                canActivate: [authGuard]
            },
        ],
        canActivate: [setupBlockGuard]
    },

    // Public story page — opened when a QR code is scanned (no auth required)
    {
        matcher: productMatcher,
        loadComponent: () =>
            import('./features/product/product')
                .then(c => c.Product),
        title: 'Product Story - FoodTraze'
    },

    {
        path: '404',
        loadComponent: () =>
            import('./features/page-not-found/page-not-found.component')
                .then(c => c.PageNotFoundComponent),
        title: 'Page Not Found - FoodTraze',
        canActivate: [authGuard]
    },
    {
        path: '**',
        loadComponent: () =>
            import('./features/page-not-found/page-not-found.component')
                .then(c => c.PageNotFoundComponent),
        title: 'Page Not Found - FoodTraze',
        canActivate: [authGuard]
    }
];
